import { getWorkflowTemplate } from "../data/workflowTemplates";
import { WORKFLOW_EDGE_OPTIONS } from "./workflowBuilderTheme";
import { DEFAULT_SESSION_TIMEOUT_SECONDS, mapWorkflowDefinitionToFlow } from "./workflowFlowMapper";

const EMPTY_CANVAS = {
  name: "Untitled Workflow",
  nodes: [],
  edges: [],
  start: "",
  sessionTimeoutSeconds: DEFAULT_SESSION_TIMEOUT_SECONDS,
  globalTransitions: {}
};

const AI_DEMO_CANVAS = {
  name: "AI Generated Flow",
  nodes: [
    { id: "1", type: "trigger", position: { x: 250, y: 50 }, data: { label: "Keyword Received", description: "Keyword: Support" } },
    { id: "2", type: "ai", position: { x: 250, y: 230 }, data: { label: "AI Response", description: "Using Knowledge Base to answer" } },
    { id: "3", type: "condition", position: { x: 250, y: 410 }, data: { label: "Condition", description: "If escalate_if_low_confidence is true" } },
    { id: "4", type: "action", position: { x: 550, y: 410 }, data: { label: "Action", description: "Assign to Human Agent" } },
    { id: "5", type: "message", position: { x: 550, y: 590 }, data: { label: "Message", description: "An agent will be with you shortly." } }
  ],
  edges: [
    { id: "e1-2", source: "1", target: "2", ...WORKFLOW_EDGE_OPTIONS },
    { id: "e2-3", source: "2", target: "3", ...WORKFLOW_EDGE_OPTIONS },
    { id: "e3-4", source: "3", sourceHandle: "onTrue", target: "4", ...WORKFLOW_EDGE_OPTIONS },
    { id: "e4-5", source: "4", target: "5", ...WORKFLOW_EDGE_OPTIONS }
  ],
  start: "1",
  sessionTimeoutSeconds: DEFAULT_SESSION_TIMEOUT_SECONDS,
  globalTransitions: {}
};

/** Resolve canvas state for new / AI workflow routes from navigation state. */
export function resolveNewWorkflowCanvas(routeId, locationState = {}) {
  const navState = locationState ?? {};
  const workflowName = navState.workflowName?.trim() || "Untitled Workflow";

  if (routeId === "new-flow-ai") {
    return { ...AI_DEMO_CANVAS, name: workflowName };
  }

  if (routeId !== "new") {
    return EMPTY_CANVAS;
  }

  const template = navState.templateId ? getWorkflowTemplate(navState.templateId) : null;
  if (!template?.definition) {
    return { ...EMPTY_CANVAS, name: workflowName };
  }

  const mapped = mapWorkflowDefinitionToFlow(template.definition);
  return {
    name: workflowName,
    nodes: mapped.nodes,
    edges: mapped.edges,
    start: mapped.start,
    sessionTimeoutSeconds: mapped.sessionTimeoutSeconds,
    globalTransitions: mapped.globalTransitions
  };
}
